// src/components/SimCCCDAnalyzer.jsx
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Stack,
  FormLabel,
  FormControl,
  Radio,
  MenuItem,
  RadioGroup,
  Hidden,
  InputBase,
  IconButton,
  Fab,
} from '@mui/material';

import solarlunar from 'solarlunar';

import {
  analyzeCCCDFull,
  ENERGY_DETAILS,
  analyzePhoneEnergy,
  ENERGY_COMBINATIONS,
  NANG_LUONG,
  BOSOKETHOP,
  getThongTinThanChu,
  TongKetSoDuoi,
  tomtatDuNien,
} from '../LogicSearch/kimKinhDich';
import classNames from 'classnames/bind';
import styles from './KinhDich.module.scss';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SimBieuDoMui from './simBieuDo';
import { fromPrettyParam, getLocalStorage, numberFormat, setLocalStorage } from '../../../utils/helper';
import { listUserID } from '../../../services/apiUsers';
import { ThemeContext } from '../../../component/ThemeContext/ThemeContext';
import SimJobGroups from './SimJobGroups';
import images from '../../../assets/images';
import SearchIcon from '@mui/icons-material/Search';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { getSimBatCuc, timSimPT, xembclsKinhDich } from '../../../services/listSim';
import { showMenhSim } from '../LogicSearch/LogicCategoryShowName';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import SimHopMenh from './SimHopMenh';
import SearchSimKinhDich from './SearchSimKinhDich';
const cx = classNames.bind(styles);
const TRIGRAMS = {
  Càn: ['yang', 'yang', 'yang'],
  Đoài: ['yin', 'yang', 'yang'],
  Ly: ['yang', 'yin', 'yang'],
  Chấn: ['yin', 'yin', 'yang'],
  Tốn: ['yang', 'yang', 'yin'],
  Khảm: ['yin', 'yang', 'yin'],
  Cấn: ['yang', 'yin', 'yin'],
  Khôn: ['yin', 'yin', 'yin'],
};

const normalizeClass = (text) => {
  if (!text || typeof text !== 'string') return ''; // fallback
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '');
};

export default function HomeKinhDich() {
  const hostname = window.location.hostname;

  const [cccd, setCccd] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneUrl, setPhoneUrl] = useState('');
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [hour, setHour] = useState('');
  const [info, setInfo] = useState(null);
  const [messageErro, setMessageErro] = useState('');

  const [isLunar, setIsLunar] = useState(true);
  const [gender, setGender] = useState('nam');
  const [report, setReport] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [analysis, setAnalysis] = useState(null);
  const [analysisPhone, setAnalysisPhone] = useState(null);
  const [arrDienNien, setArrDienNien] = useState(null);
  const [arrSim, setArrSim] = useState(null);
  const navigate = useNavigate();

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  // const textDuNienIn = urlParams.get('dn') ? fromPrettyParam(urlParams.get('dn')) : null;
  const phoneDuNien = urlParams.get('so');
  const textSimSo = urlParams.get('q');
  const ngayDuNien = urlParams.get('ngay');
  const thangDuNien = urlParams.get('thang');
  const namDuNien = urlParams.get('nam');
  const gioDuNien = urlParams.get('gio');
  const cccdDuNien = urlParams.get('cccd');
  const gioitinhDuNien = urlParams.get('gioitinh');
  const lichDuNien = urlParams.get('lich');
  const [isFixed, setIsFixed] = useState(false);
  const [textSimSearch, setTextSimSearch] = useState('');
  let arrShop = getLocalStorage('addShop')?.length || 0;

  const checkUrlXemPhongThuy = location.pathname === '/xem-phong-thuy' ? true : false;
  const checkUrlNgheNghiep = location.pathname === '/sim-theo-nghe-nghiep' ? true : false;
  const checkUrlHopMenh = location.pathname === '/sim-hop-menh' ? true : false;
  const checkUrlHome = location.pathname === '/' ? true : false;
  const checkUrlSoDep = location.pathname === '/so-dep' ? true : false;

  const getSimDuNien = async () => {
    const resultSIM = await getSimBatCuc(hostname, 1, 70);
    if (resultSIM?.datasim?.data?.length > 0) {
      setArrSim(resultSIM?.datasim?.data);
    }
  };

  const handleSearch = () => {
    navigate(`/so-dep?q=${textSimSearch}`, { replace: true });
    window.location.reload();
  };
  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      setTextSimSearch(e.target.value);
      navigate(`/so-dep?q=${textSimSearch}`, { replace: true });
      window.location.reload();
    }
  };

  const checkParam = () => {
    const dmySim = getLocalStorage('dmy');
    if (checkUrlXemPhongThuy && ngayDuNien) {
      if (ngayDuNien) {
        setDay(ngayDuNien);
      }
      if (thangDuNien) {
        setMonth(thangDuNien);
      }
      if (namDuNien) {
        setYear(namDuNien);
      }
      if (gioDuNien) {
        setHour(gioDuNien);
      }
      if (cccdDuNien) {
        setCccd(cccdDuNien);
      }
      if (gioitinhDuNien) {
        setGender(gioitinhDuNien);
      }
      if (lichDuNien) {
        setIsLunar(lichDuNien === 'al' ? true : false);
      }
    } else if (dmySim) {
      setDay(dmySim?.day);
      setMonth(dmySim?.month);
      setYear(dmySim?.year);
      setHour(dmySim?.hour);
      setCccd(dmySim?.cccd);
      setIsLunar(dmySim?.lich);
      setGender(dmySim?.gender);
    }
    if (phoneDuNien) {
      setPhone(phoneDuNien);
      setPhoneUrl(phoneDuNien);
    }
    if (textSimSo) {
      setTextSimSearch(textSimSo);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsFixed(true);
      }
      if (window.scrollY < 200) {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    document.title = 'Xem bói sim phong thủy Kinh Dịch  - Theo Năng Lượng Số';
    if (checkUrlHome) {
      getSimDuNien();
    }
    checkParam();
  }, []);

  useEffect(() => {
    if (ngayDuNien && phoneUrl && checkUrlXemPhongThuy) {
      handleAnalyze();
    }
  }, [ngayDuNien, phoneUrl]);

  const timSim = async (date = '', sim = '', cccd = '', status = 1) => {
    await timSimPT(date, sim, cccd, status, hostname);
  };
  const handleAnalyze = async () => {
    setAnalysis(null);
    setReport(null);
    setAnalysisPhone(null);
    setSelectedIndex(null);
    setArrDienNien(null);
    if (phone === '') {
      setMessageErro('Bạn chưa nhập số điện thoại hoặc nhập sai');
    } else if (day === '' || month === '' || year === '' || hour === '') {
      setMessageErro('Bạn chưa nhập đủ ngày/tháng/năm + giờ sinh');
    } else {
      setMessageErro('');
      let d = Number(day),
        m = Number(month),
        y = Number(year);

      if (!isLunar) {
        const lunar = solarlunar.solar2lunar(y, m, d);
        d = lunar.lDay;
        m = lunar.lMonth;
        y = lunar.lYear; // chuẩn hóa dùng DL cho tính TK
      }

      const birthInfo = { day: Number(d), month: Number(m), year: Number(y) };

      setLocalStorage('dmy', {
        day: day,
        month: month,
        year: year,
        hour: hour,
        cccd: cccd,
        lich: isLunar,
        gender: gender,
      });

      // All giữ liệu
      const dataBcls = {
        phone: phone,
        cccd: cccd,
        birthInfo: birthInfo,
      };

      const allBcls = await xembclsKinhDich(dataBcls);
      if (allBcls?.success) {
        setAnalysis(allBcls?.data);
        if (allBcls?.data?.cccdAnalysis) {
          setReport(allBcls?.data?.cccdAnalysis);
          setSelectedIndex(allBcls?.data?.cccdAnalysis?.currentSegmentIndex || 0);
        }
        setAnalysisPhone(allBcls?.data?.phoneAnalysis);

        const simPairs = Array.isArray(allBcls?.data?.phoneAnalysis?.pairs) ? allBcls?.data?.phoneAnalysis?.pairs : [];
        const simEnergies = simPairs.filter((item) => item.energyName !== 'Phục Vị');
        setArrDienNien(simEnergies);
      }
      await timSim(`${day}/${month}/${year}-${isLunar ? `al` : `dl`}-${gender}`, phone, cccd, 2);
      const data = getThongTinThanChu({
        day: Number(day),
        month: Number(month),
        year: Number(year),
        hourLabel: hour, // vd "Mão (05h-07h)"
        isLunar,
        gender, // 'nam' | 'nu'
      });
      setInfo(data);
    }
  };

  const renderEnergyCellText = (mapped) => {
    if (!mapped) return 'Không xác định';
    if (!mapped.energyName) return 'Không xác định';
    // show group string if group-priority
    if (mapped.groupStr) return `${mapped.energyName} <br/> (${mapped.groupStr})`;
    return mapped.energyName;
  };
  const renderEnergyCellTexts = (mapped) => {
    if (!mapped) return 'Không xác định';
    if (!mapped.energyName) return 'Không xác định';
    // show group string if group-priority
    if (mapped.groupStr) return `${mapped.energyName} (${mapped.groupStr})`;
    return mapped.energyName;
  };

  const renderEnergyDetails = (mapped) => {
    if (!mapped || !mapped.energyName) return <em>Không xác định</em>;
    const parts = mapped.energyName.split('+').map((p) => p.trim());
    return (
      <Box>
        <h2 style={{ marginBottom: 10, textAlign: 'center', fontSize: '30px', color: '#a8441e' }}>
          <b>🔮 Đại vận căn cước: {renderEnergyCellTexts(mapped)}</b>
        </h2>
        {parts.map((p) => {
          const d = ENERGY_DETAILS[p];
          if (!d)
            return (
              <Paper key={p} sx={{ p: 1, mb: 1 }}>
                <Typography>{p} — (chưa có mô tả chi tiết)</Typography>
              </Paper>
            );
          return (
            <div key={p} style={{ padding: 5, fontSize: 16 }}>
              <div style={{ marginBottom: 5 }}>
                <b>Ngũ hành:</b> <span className={cx(`${d.lug}-size`)}>{d.nguHanh}</span>
              </div>
              <div style={{ marginBottom: 15 }}>
                <b>Chòm sao:</b> <span className={cx(`${d.lug}-size`)}>{d.chomSao}</span>
              </div>
              <div>
                <strong style={{ color: '#9c6013' }}>
                  💡 Đặc điểm của đại vận căn cước {mapped.energyName}: <br />
                </strong>
                {d.dacDiem
                  ?.split(/(?<!\.)\.(?!\.)/)
                  .filter((p) => p.trim() !== '') // bỏ đoạn rỗng nếu có
                  .map((p, idx) => (
                    <p key={idx} style={{ marginBottom: 10 }}>
                      {p.trim()}.
                    </p>
                  ))}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#2c7a7b' }}>
                  ✨ Ưu điểm: <br />
                </strong>{' '}
                {Array.isArray(d.uuDiem) ? d.uuDiem.join(', ') : d.uuDiem}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#b23c2b' }}>
                  ⚠️ Khuyết điểm: <br />
                </strong>{' '}
                {Array.isArray(d.khuyetDiem) ? d.khuyetDiem.join(', ') : d.khuyetDiem}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#d4a017' }}>
                  💰 Tài vận:
                  <br />
                </strong>{' '}
                {d.taiVan}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#3b7d4a' }}>
                  🛠 Sự nghiệp:
                  <br />
                </strong>{' '}
                {d.suNghiep}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#a0527f' }}>
                  ❤️ Tình cảm/hôn nhân:
                  <br />
                </strong>{' '}
                {d.honNhan}
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong style={{ color: '#b23c2b' }}>
                  🩺 Sức khỏe:
                  <br />
                </strong>{' '}
                {d.sucKhoe}
              </div>
              <div style={{ marginTop: 10, borderRadius: 5, padding: 10, backgroundColor: '#cccccc30' }}>
                <span>
                  <i>
                    Những nội dung trên chỉ mang tính chất tham khảo từ các sách, tài liệu. Nếu có ngôn từ quá tiêu cực,
                    xấu thì cũng đừng vội hoang mang. Hãy liên hệ với chúng tôi nếu cần thiết.
                  </i>
                </span>
              </div>
            </div>
          );
        })}
      </Box>
    );
  };

  const findSequentialPositions = (clean, groups) => {
    let searchStart = 0;
    return groups.map((g) => {
      const pos = clean.indexOf(g.groupStr, searchStart);
      if (pos !== -1) {
        searchStart = pos + 1; // dịch sang sau vị trí tìm thấy để không quay ngược
      }
      return pos;
    });
  };

  return (
    <Grid container className={cx('body')} justifyContent={'center'} spacing={1} sx={{ p: 0, pb: '60px' }}>
      <Hidden only={['sm', 'xs']}>
        <Container className={cx('mt-5')}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {' '}
            <Paper
              elevation={3}
              sx={{
                height: '35px',
                marginTop: '5px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: 10,
                width: '272px',
              }}
              className={cx('filter-color')}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={`Nhập số sim cần tìm ...`}
                inputProps={{ 'aria-label': 'Tìm kiếm sim số' }}
                value={textSimSearch}
                onChange={(e) => setTextSimSearch(e.target.value)}
                onKeyPress={handleEnterKey}
                fullWidth
              />
              {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}

              <IconButton
                sx={{ m: '2px', p: '4px' }}
                className={cx('bgr-default')}
                aria-label="directions"
                onClick={handleSearch}
              >
                <SearchIcon sx={{ color: 'aliceblue' }} />
              </IconButton>
            </Paper>
            <Box>
              <Box sx={{ mt: 1 }}>
                <Stack direction="column" alignItems="center">
                  <Button component={Link} to="/gio-hang" variant="contained" color="warning" sx={{ borderRadius: 5 }}>
                    <AddShoppingCartIcon /> {arrShop > 0 ? `(${arrShop})` : ''}
                  </Button>
                </Stack>
              </Box>
            </Box>
          </div>
        </Container>
      </Hidden>
      <Grid item xs={12} md={12} className={cx('logo', 'flex-center')}>
        <Link to={'/'}>
          <img src={images?.logo_kinhdich} alt="kinhdichsim" />
        </Link>
      </Grid>
      <Hidden only={['md', 'lg', 'xl']}>
        <div className={cx('wrapper-layout2-mobi', `${isFixed ? 'is-sticky' : ''}`)}>
          <div className={cx('inner')}>
            <Grid container>
              <Grid item xs={12} sx={{ marginTop: '3px' }}>
                <Paper
                  elevation={3}
                  sx={{
                    height: '35px',
                    marginTop: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: 10,
                  }}
                  className={cx('filter-color')}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder={`Nhập số sim cần tìm ...`}
                    inputProps={{ 'aria-label': 'Tìm kiếm sim số' }}
                    value={textSimSearch}
                    onChange={(e) => setTextSimSearch(e.target.value)}
                    onKeyPress={handleEnterKey}
                    fullWidth
                  />
                  {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}

                  <IconButton
                    sx={{ m: '2px', p: '4px' }}
                    className={cx('bgr-default')}
                    aria-label="directions"
                    onClick={handleSearch}
                  >
                    <SearchIcon sx={{ color: 'aliceblue' }} />
                  </IconButton>
                </Paper>
              </Grid>
            </Grid>
          </div>
        </div>
      </Hidden>
      <Hidden only={['md', 'lg', 'xl']}>
        <Stack direction="row" spacing={1} className={cx('stack-scroll')}>
          <div className={cx('menu_sim')}>
            {' '}
            <a href="/xem-phong-thuy">
              <span className={cx(`${checkUrlXemPhongThuy ? 'color-menu-url' : 'color-white'}`)}>
                {' '}
                Chấm điểm phong thuỷ
              </span>
            </a>
          </div>
          <div className={cx('menu_sim')}>
            <a href="/sim-hop-menh">
              <span className={cx(`${checkUrlHopMenh ? 'color-menu-url' : 'color-white'}`)}>Tìm sim hợp tuổi</span>
            </a>
          </div>
          <div className={cx('menu_sim')}>
            {' '}
            <a href="/sim-theo-nghe-nghiep">
              {' '}
              <span className={cx(`${checkUrlNgheNghiep ? 'color-menu-url' : 'color-white'}`)}>
                {' '}
                Tìm sim ngành nghề
              </span>
            </a>
          </div>
        </Stack>
      </Hidden>

      <Hidden only={['sm', 'xs']}>
        <Container sx={{ p: 0 }} maxWidth="lg">
          <div className={cx('mtop', 'mb-10')}>
            <div className={cx('menu')}>
              <a href="/">
                <img src={images?.m_home} alt="trang chủ" style={{ height: '76px', marginTop: '11px' }} />
              </a>
              <a href="/sim-hop-menh">
                <span className={cx(`${checkUrlHopMenh ? 'color-menu-url' : ''}`)}>Tìm sim hợp tuổi</span>
              </a>
              <div className={cx('chia')}></div>
              <a href="/sim-theo-nghe-nghiep">
                {' '}
                <span className={cx(`${checkUrlNgheNghiep ? 'color-menu-url' : ''}`)}> Tìm sim ngành nghề</span>
              </a>
              <div className={cx('chia')}></div>
              <a href="/xem-phong-thuy">
                <span className={cx(`${checkUrlXemPhongThuy ? 'color-menu-url' : ''}`)}> Chấm điểm phong thuỷ</span>
              </a>
              {/* <div className={cx('chia')}></div> */}
            </div>
          </div>
        </Container>
      </Hidden>

      {/* Ô CHẤM ĐIỂM PHONG THỦY SIM  */}
      {checkUrlXemPhongThuy && (
        <Grid item xs={12} md={12}>
          <div>
            <div className={cx('bgr-search', 'pt-10')}>
              <h2 className={cx('title-search-2')}>Xem Sim Phong Thủy</h2>
              <h2 className={cx('title-search')}>Giải Mã Vận Mệnh, Khai Mở Tài Lộc</h2>

              <div className={cx('form-row')}>
                <input
                  type="text"
                  placeholder="Số căn cước (CCCD)"
                  className={cx('form-input')}
                  value={cccd}
                  onChange={(e) => {
                    setCccd(e.target.value?.replace(/\D/g, ''));
                    setAnalysis(null);
                  }}
                />
                <input
                  type="text"
                  placeholder="Số điện thoại *"
                  className={cx('form-input')}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.replace(/\D/g, ''));
                    setAnalysis(null);
                  }}
                />
              </div>

              <div className={cx('form-row')}>
                <select
                  className={cx('form-select')}
                  value={day}
                  onChange={(e) => {
                    setDay(e.target.value);
                    setAnalysis(null);
                  }}
                >
                  <option value="">Ngày sinh *</option>
                  {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>

                <select
                  className={cx('form-select')}
                  value={month}
                  onChange={(e) => {
                    setMonth(e.target.value);
                    setAnalysis(null);
                  }}
                >
                  <option value="">Tháng sinh *</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>

                <input
                  type="number"
                  placeholder="Năm sinh *"
                  className={cx('form-input')}
                  value={year}
                  onChange={(e) => {
                    setYear(e.target.value);
                    setAnalysis(null);
                  }}
                />
              </div>

              <div className={cx('form-row')}>
                <select
                  className={cx('form-select')}
                  value={hour}
                  onChange={(e) => {
                    setHour(e.target.value);
                    setAnalysis(null);
                  }}
                >
                  <option value="">Giờ sinh *</option>
                  {[
                    'Tý (23h-01h)',
                    'Sửu (01h-03h)',
                    'Dần (03h-05h)',
                    'Mão (05h-07h)',
                    'Thìn (07h-09h)',
                    'Tỵ (09h-11h)',
                    'Ngọ (11h-13h)',
                    'Mùi (13h-15h)',
                    'Thân (15h-17h)',
                    'Dậu (17h-19h)',
                    'Tuất (19h-21h)',
                    'Hợi (21h-23h)',
                  ].map((g) => (
                    <option key={g} value={g}>
                      {g}
                    </option>
                  ))}
                </select>
              </div>

              <div className={cx('form-row')}>
                <div className={cx('form-radio-inline')}>
                  <span className={cx('radio-label')}>Loại lịch*:</span>
                  <label>
                    <input
                      type="radio"
                      name="calendar"
                      value="dl"
                      checked={!isLunar}
                      onChange={() => {
                        setIsLunar(false);
                        setAnalysis(null);
                      }}
                    />
                    Dương lịch
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="calendar"
                      value="al"
                      checked={isLunar}
                      onChange={() => {
                        setIsLunar(true);
                        setAnalysis(null);
                      }}
                    />
                    Âm lịch
                  </label>
                </div>

                <div className={cx('form-radio-inline')}>
                  <span className={cx('radio-label')}>Giới tính*:</span>
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      value="nam"
                      checked={gender === 'nam'}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setAnalysis(null);
                      }}
                    />
                    Nam
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="gender"
                      value="nu"
                      checked={gender === 'nu'}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setAnalysis(null);
                      }}
                    />
                    Nữ
                  </label>
                </div>
              </div>
              {messageErro && (
                <div>
                  <b className={cx('red')}>{messageErro}</b>
                </div>
              )}
              <div className={cx('form-action', 'justify-center')}>
                <button className={cx('nut')} onClick={handleAnalyze}>
                  LUẬN GIẢI SIM
                </button>
              </div>
            </div>
          </div>
          <Container sx={{ p: '5px' }}>
            {analysis && (
              <div className={cx('brg-container')}>
                <div>
                  <div className={cx('simboi')}>
                    <span>XEM PHONG THỦY NĂNG LƯỢNG SIM {phone}</span>
                  </div>
                  <div className={cx('title-chart', 'mt-10')}>
                    <h2> Khái quát về mệnh cục cá nhân</h2>
                  </div>
                  {info && (
                    <div className={cx('info-box')}>
                      <h3 className={cx('info-title')}>Thông Tin Thân Chủ</h3>

                      <div className={cx('info-content')}>
                        <div className={cx('info-left')}>
                          <p>
                            <span className={cx('label')}>Dương lịch:</span> {info.duongLich}
                          </p>
                          <p>
                            <span className={cx('label')}>Âm lịch:</span> {info.amLich}
                          </p>
                          <p>
                            <span className={cx('label')}>Tiết Khí:</span> {info.tietKhi}
                          </p>
                          <p>
                            <span className={cx('label')}>Giới tính:</span> {info.gioiTinh}
                          </p>
                          <p>
                            <span className={cx('label')}>Cung mệnh:</span> {info.cungMenh}
                          </p>
                          <p>
                            <span className={cx('label')}>Bản Mệnh:</span> {info.banMenh}
                          </p>
                        </div>

                        <div className={cx('info-right')}>
                          <div className={cx('bagua-circle')}>
                            <div className={cx('trigram')}>
                              {(TRIGRAMS[info.cungMenh] || []).map((line, i) => (
                                <div key={i} className={cx('line', line)} />
                              ))}
                            </div>
                            <div className={cx('trigram-number')}>{info.soQue}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {report && cccd && (
                  <div className={cx('title-chart', 'mt-20')}>
                    <h2> Luận năng lượng số căn cước {cccd} </h2>
                  </div>
                )}
                {report && cccd && (
                  <>
                    <Box sx={{ p: 2, borderRadius: 1, mb: 2 }}>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title')}>
                        Các cặp năng lượng trong số căn cước
                      </Stack>
                      <div className={cx('number-box')}>
                        {' '}
                        {report.groupStrings.map((g, idx) => (
                          <span key={idx} className={cx('number-item')}>
                            {g}{' '}
                          </span>
                        ))}
                      </div>
                      {/* <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                Chuỗi ghép dùng tạo "Số năng" (concat groups): {report.concat}
              </Typography> */}
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <div className={cx('title-daivan')}>ĐẠI VẬN TRÌNH CĂN CƯỚC</div>

                      <TableContainer component={Paper}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 700, fontSize: '20px' }}>
                                Số <br /> năng
                              </TableCell>
                              {report.assigned.map((a, i) => (
                                <TableCell
                                  key={i}
                                  align="center"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: '20px',

                                    color:
                                      report.currentSegment && report.currentSegment.label === a.segment.label
                                        ? '#ff0000'
                                        : '#000',
                                  }}
                                >
                                  {a.pair}
                                </TableCell>
                              ))}
                            </TableRow>

                            <TableRow>
                              <TableCell sx={{ fontWeight: 700 }}>Tuổi</TableCell>
                              {report.assigned.map((a) => (
                                <TableCell
                                  key={a.index}
                                  align="center"
                                  sx={{
                                    fontWeight: 700,
                                    color:
                                      report.currentSegment && report.currentSegment.label === a.segment.label
                                        ? '#ff0000'
                                        : '#000',
                                  }}
                                >
                                  {a.segment.label}
                                </TableCell>
                              ))}
                            </TableRow>

                            <TableRow>
                              <TableCell sx={{ fontWeight: 700 }}>
                                Từ <br /> trường <br /> vận
                              </TableCell>
                              {report.assigned.map((a, i) => (
                                <TableCell
                                  key={i}
                                  align="center"
                                  sx={{
                                    color:
                                      report.currentSegment && report.currentSegment.label === a.segment.label
                                        ? '#ff0000'
                                        : '#000',
                                  }}
                                >
                                  <span dangerouslySetInnerHTML={{ __html: renderEnergyCellText(a.mapped) }} />
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                        </Table>
                      </TableContainer>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Box sx={{ mt: 1 }}>
                        {report.assigned[report.currentSegmentIndex] && (
                          <div className={cx('bgr-nau')}>
                            {renderEnergyDetails(report.assigned[report.currentSegmentIndex].mapped)}
                          </div>
                        )}
                      </Box>
                    </Box>
                  </>
                )}

                {analysis && (
                  <Box className={cx('bgr-trang')}>
                    {/* Hiển thị cặp số */}
                    <Box sx={{ mb: 2, borderRadius: 5 }}>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title')}>
                        Các cặp năng lượng trong số sim
                      </Stack>
                      <div className={cx('number-box')}>
                        {' '}
                        {analysisPhone?.pairs?.map((pair, i) => (
                          <span key={i} className={cx('number-item')}>
                            {pair.groupStr}{' '}
                          </span>
                        ))}
                      </div>
                      <Box sx={{ mt: 1 }}>
                        {analysisPhone.pairs.map((pair, idx) => {
                          const pairPositions = analysisPhone
                            ? findSequentialPositions(phone, analysisPhone.pairs)
                            : [];

                          const start = pairPositions[idx];
                          const end = start + pair.groupStr.length;

                          return (
                            <>
                              <Box
                                key={idx}
                                sx={{ display: 'flex', alignItems: 'baseline' }}
                                className={cx('mobile-show-so')}
                              >
                                <div className={cx('font-27', 'good_so', 'font-bold', 'good')}>
                                  <span className={cx('mr-5', 'ml-5')}>Cặp số</span>
                                  {phone.split('').map((ch, i) => {
                                    const inGroup = start !== -1 && i >= start && i < end;
                                    return (
                                      <span
                                        key={i}
                                        style={{
                                          color: inGroup ? 'red' : 'black',
                                          fontSize: inGroup ? '2.5rem' : '27px',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {ch}
                                      </span>
                                    );
                                  })}{' '}
                                  :
                                </div>

                                {pair.energyName && (
                                  <div>
                                    <b
                                      style={{ marginLeft: '10px' }}
                                      className={cx('font-27', NANG_LUONG[pair.energyName]?.lug + '-size')}
                                    >
                                      {pair.groupStr}
                                      {' - '}
                                    </b>
                                    {'  '}
                                    <span>
                                      <b className={cx(NANG_LUONG[pair.energyName]?.lug)}>{pair.energyName}</b>
                                      <b className={cx(NANG_LUONG[pair.energyName]?.lug + '-size', 'font-27')}>
                                        {' '}
                                        ({NANG_LUONG[pair.energyName].nguHanh})
                                      </b>
                                    </span>
                                  </div>
                                )}
                              </Box>
                              <Box>
                                <p className={cx('css-dacdiem', 'mt-10')}>
                                  <b>Đặc điểm:</b>
                                </p>
                                {pair.energyName && (
                                  <div>
                                    {NANG_LUONG[pair.energyName]?.general
                                      ?.split(/(?<!\.)\.(?!\.)/)
                                      .filter((p) => p.trim() !== '') // bỏ đoạn rỗng nếu có
                                      .map((p, idx) => (
                                        <p key={idx} className={cx('css-detail')}>
                                          {p.trim()}.
                                        </p>
                                      ))}
                                  </div>
                                )}
                              </Box>
                            </>
                          );
                        })}
                      </Box>
                    </Box>

                    {/* Hiển thị tam số */}
                    <div className={cx('dunien-content')} />
                    <Box>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title3s')}>
                        Các xét sự giao thoa của 2 năng lượng - TAM SỐ THÀNH TƯỢNG
                      </Stack>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title3sdes')}>
                        <span>
                          {' '}
                          Sự giao thoa của 2 năng lượng kế nhau có thể quyết định sự thành bại của dãy số: Hung tinh gặp
                          cát tinh có thể hóa hung thành cát.{' '}
                        </span>
                      </Stack>
                      <div className={cx('number-box')}>
                        {' '}
                        {analysisPhone?.triplets.map((triad, idx) => (
                          <span key={idx} className={cx('number-item')}>
                            {triad.groupStr}
                          </span>
                        ))}
                      </div>
                      <br />

                      <Box sx={{ mt: 1 }}>
                        {analysisPhone.triplets.map((triad, idx) => {
                          const tripletPositions = analysisPhone
                            ? findSequentialPositions(phone, analysisPhone.triplets)
                            : [];

                          const start = tripletPositions[idx];
                          const end = start + triad.groupStr.length;

                          return (
                            <>
                              <Box
                                key={idx}
                                sx={{ display: 'flex', alignItems: 'baseline' }}
                                className={cx('mobile-show-so')}
                              >
                                <div className={cx('font-27', 'good_so', 'font-bold')}>
                                  <span className={cx('mr-5', 'ml-5')}> Bộ số </span>
                                  {phone.split('').map((ch, i) => {
                                    const inGroup = start !== -1 && i >= start && i < end;
                                    return (
                                      <span
                                        key={i}
                                        style={{
                                          color: inGroup ? 'red' : 'black',
                                          fontSize: inGroup ? '2.5rem' : '27px',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {ch}
                                      </span>
                                    );
                                  })}{' '}
                                  <b className={cx('font-27')}>({triad.groupStr})</b>:{' '}
                                </div>{' '}
                                {triad.energyName && (
                                  <div className={cx('ml-5')}>
                                    <span>
                                      <b className={cx(BOSOKETHOP[triad.energyName]?.nl1?.lug, 'mr-5')}>
                                        {BOSOKETHOP[triad.energyName]?.nl1?.name}
                                      </b>
                                      {' + '}
                                      <b className={cx(BOSOKETHOP[triad.energyName]?.nl2?.lug)}>
                                        {BOSOKETHOP[triad.energyName]?.nl2?.name}
                                      </b>
                                    </span>
                                  </div>
                                )}
                              </Box>
                              <Box>
                                <p className={cx('css-dacdiem', 'mt-10')}>
                                  <b>Đặc điểm:</b>
                                </p>
                                {triad.energyName && (
                                  <div>
                                    {ENERGY_COMBINATIONS[triad.energyName]?.general
                                      ?.split(/(?<!\.)\.(?!\.)/)
                                      .filter((p) => p.trim() !== '') // bỏ đoạn rỗng nếu có
                                      .map((p, idx) => (
                                        <p key={idx} className={cx('css-detail')}>
                                          {p.trim()}.
                                        </p>
                                      ))}
                                  </div>
                                )}
                              </Box>
                            </>
                          );
                        })}
                      </Box>
                    </Box>
                    <div className={cx('dunien-content')} />
                    <Box>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title', 'mb-10')}>
                        TRỌNG ĐIỂM DÃY SỐ
                      </Stack>
                      {!analysisPhone.pairs?.at(-1)?.groupStr.includes('0') ? (
                        <div className={cx('note-box-nau')}>
                          {analysisPhone.pairs?.at(-1)?.energyName && (
                            <div className={cx('dunien-content')}>
                              <h3
                                className={cx(
                                  'title-dunien',
                                  `${
                                    ['Tuyệt Mệnh', 'Họa Hại', 'Lục Sát', 'Ngũ Quỷ'].includes(
                                      arrDienNien?.at(-1)?.energyName,
                                    )
                                      ? 'bad'
                                      : 'good'
                                  }`,
                                )}
                              >
                                Sim kết thúc với Bộ số cuối là {analysisPhone.pairs?.at(-1).groupStr}, đây là bộ số quan
                                trọng nhất trong dãy số.
                              </h3>
                            </div>
                          )}
                          {['Tuyệt Mệnh', 'Họa Hại', 'Lục Sát', 'Ngũ Quỷ'].includes(
                            arrDienNien?.at(-1)?.energyName,
                          ) && (
                            <div>
                              {analysisPhone.pairs?.at(-1).energyName === 'Phục Vị' && (
                                <p>
                                  <span className={cx('head-title')}>
                                    Phục Vị có thể coi là bộ năng lượng kế vị theo năng lượng trước đó.
                                  </span>
                                </p>
                              )}
                              <p>
                                Đây có thể coi là một bộ số năng lượng xấu (
                                <strong style={{ color: 'black', fontWeight: 'bold' }}>
                                  {arrDienNien?.at(-1)?.energyName}
                                </strong>
                                )
                              </p>
                              <p>
                                <span className={cx('head-title')}>Đặc điểm của Hung Tinh:</span>
                              </p>
                            </div>
                          )}
                          {['Thiên Y', 'Sinh Khí', 'Diên Niên'].includes(arrDienNien?.at(-1)?.energyName) && (
                            <div>
                              {analysisPhone.pairs?.at(-1).energyName === 'Phục Vị' && (
                                <p>
                                  <span className={cx('head-title')}>
                                    Phục Vị có thể coi là bộ năng lượng kế vị theo năng lượng trước đó.
                                  </span>
                                </p>
                              )}
                              <p>
                                Đây là một bộ số năng lượng tốt (
                                <strong style={{ color: 'red', fontWeight: 'bold' }}>
                                  {' '}
                                  {arrDienNien?.at(-1).energyName}
                                </strong>
                                )
                              </p>
                              <p>
                                <span className={cx('head-title')}>
                                  Đặc điểm của {analysisPhone.pairs?.at(-1).energyName}:
                                </span>
                              </p>
                            </div>
                          )}

                          {arrDienNien?.at(-1)?.energyName && (
                            <div>
                              {TongKetSoDuoi[arrDienNien?.at(-1).energyName]
                                // tách bằng dấu chấm đơn, nhưng KHÔNG tách khi có 2+ chấm liên tiếp
                                ?.split(/(?<!\.)\.(?!\.)/)
                                .filter((p) => p.trim() !== '') // bỏ đoạn rỗng nếu có
                                .map((p, idx) => (
                                  <p key={idx}>{p.trim()}.</p>
                                ))}
                            </div>
                          )}
                          {/* ------------------------- */}
                          {analysisPhone.triplets?.at(-1).energyName && (
                            <div className={cx('mt-10', 'p-10')}>
                              <h3
                                className={cx(
                                  'title-dunien',
                                  `${
                                    ['Tuyệt Mệnh', 'Họa Hại', 'Lục Sát', 'Ngũ Quỷ'].includes(
                                      arrDienNien?.at(-1)?.energyName,
                                    )
                                      ? 'bad'
                                      : 'good'
                                  }`,
                                )}
                              >
                                Sim kết thúc bằng cặp năng lượng cuối là {analysisPhone.triplets?.at(-1).energyName} (
                                {analysisPhone.triplets?.at(-1).groupStr})
                              </h3>
                            </div>
                          )}

                          {analysisPhone.triplets?.at(-1).energyName && (
                            <div>
                              <p>
                                <span className={cx('head-title')}>
                                  Đặc điểm của {analysisPhone.triplets?.at(-1).energyName}:
                                </span>
                              </p>
                              {ENERGY_COMBINATIONS[analysisPhone.triplets?.at(-1).energyName]?.general
                                ?.split(/(?<!\.)\.(?!\.)/)
                                .filter((p) => p.trim() !== '') // bỏ đoạn rỗng nếu có
                                .map((p, idx) => (
                                  <p key={idx} className={cx('css-dt')}>
                                    {p.trim()}.
                                  </p>
                                ))}
                            </div>
                          )}
                        </div>
                      ) : ['Thiên Y', 'Sinh Khí', 'Diên Niên'].includes(arrDienNien?.at(-1)?.energyName) ? (
                        <div className={cx('note-box-nau')}>
                          {analysisPhone.pairs?.at(-1)?.energyName && (
                            <div className={cx('dunien-content')}>
                              <h3 className={cx('title-dunien', 'bad')}>
                                {analysisPhone.pairs?.at(-1).groupStr} - Điểm Quy Hồi Của Vận Số
                              </h3>
                              <p>
                                Đây có thể coi là một bộ số năng lượng tốt (
                                <strong style={{ color: 'red', fontWeight: 'bold' }}>
                                  {analysisPhone.pairs?.at(-1)?.energyName}
                                </strong>
                                ), nhưng do chứa số 0, nên năng lượng bị chuyển hóa thành xấu
                              </p>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className={cx('note-box-nau')}>
                          Đây là từ trường năng lượng <b>xấu</b>, lại thêm có <b>số 0</b>, số này sẽ làm tăng trường
                          năng lượng xấu, do đó cực kỳ bất lợi khi có bộ số này.
                        </div>
                      )}
                    </Box>

                    <div>
                      <SimBieuDoMui analysis={analysis} />
                    </div>

                    <div className={cx('mt-20')}>
                      <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        className={cx('font-title', 'mb-10', 'text-uppercase')}
                      >
                        Kết luận năng lượng sim
                      </Stack>
                      {analysis?.missingGood?.length > 0 &&
                        analysis?.missingGood?.map((row, i) => (
                          <div>
                            <div className={cx('note-box')} key={i}>
                              <p>
                                Dãy số không có năng lượng số <strong className={cx('red')}>{row} </strong>(các tổ hợp
                                số như: {tomtatDuNien[row]?.tohop}). {tomtatDuNien[row]?.no}
                              </p>
                            </div>
                          </div>
                        ))}
                      {analysis?.breakdown?.length > 0 &&
                        analysis?.breakdown?.map((row, i) => (
                          <div>
                            {row.name && (
                              <Stack direction={'row'} justifyContent={'center'} className={cx('font-red-20', 'mb-10')}>
                                {row.name}
                              </Stack>
                            )}
                            <div className={cx(`${row?.score <= 0 ? 'note-box-nau' : 'note-box-xanh'}`)} key={i}>
                              <div dangerouslySetInnerHTML={{ __html: row.content }} />
                              <div>
                                <span className={cx('danh-gia')}>
                                  {' '}
                                  Đánh giá: <strong className={cx('red')}>{row.score}%</strong> điểm ✓{' '}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>

                    <div className={cx('mt-20')}>
                      <Stack direction={'row'} justifyContent={'center'} className={cx('font-title3s', 'mb-10')}>
                        TỔNG KẾT
                      </Stack>
                      <div className={cx('summary-card', `${analysis?.score >= 50 ? 'summary--good' : ''}`)}>
                        <div className={cx('bg-tongdiem')}>
                          <div style={{ margin: '5px 0', fontSize: '28px', color: '#ff2b2b', fontWeight: 'bold' }}>
                            {phone}
                          </div>
                          <span style={{ fontSize: '128%' }}>
                            {' '}
                            <b>Tổng điểm:</b> <strong className={cx('red')}>{analysis?.score}%</strong>
                          </span>
                        </div>
                        <div className={cx('fontsizetitle', 'text-center')}>Đánh giá sim </div>
                        <p
                          className={cx(
                            `${analysis?.score >= 50 ? 'cat' : 'hung'}`,
                            'fontsizetitle',
                            'text-center',
                            'mt-10',
                          )}
                        >
                          {analysis?.score >= 50
                            ? `Đây là một sim có năng lượng ${analysis?.conclusion}!`
                            : 'Đây không phải là một sim có năng lượng tốt theo phương pháp Bát Cực Linh Số!'}
                        </p>
                        {analysisPhone.pairs?.at(-1)?.groupStr.includes('0') && (
                          <p className={cx('text-center', 'mt-20')}>
                            <i>
                              Lưu ý: Dãy số quá nhiều số 0 (xuất hiện 2 cái thậm chí 3 cái trở lên): 0 là hao tổn tiết
                              nguyên khí, sức khỏe dễ mệt nhọc, thậm chí phẫu thuật giải phẫu, vất vả mệt mỏi, thành tựu
                              cho người khác, thiên về tu hành.
                            </i>
                          </p>
                        )}
                      </div>
                    </div>
                  </Box>
                )}
              </div>
            )}
          </Container>
        </Grid>
      )}

      {/* Ô TÌM SIM PHONG THỦY  */}
      {(checkUrlHome || checkUrlSoDep) && <SearchSimKinhDich />}

      {/* PHONG THỦY HỢP MỆNH */}
      {(checkUrlHome || checkUrlHopMenh) && <SimHopMenh />}

      {!analysis && (checkUrlHome || checkUrlNgheNghiep) && <SimJobGroups />}
      {/* {!checkUrlXemPhongThuy && (
        <KinhDichDetail
          diennien={textDuNienIn}
          objCccd={{ day: day, month: month, year: year, hour: hour, cccd: cccd, lich: isLunar, gender: gender }}
        />
      )} */}
      {!analysis && checkUrlHome && (
        <Grid item xs={12} md={12}>
          <Container sx={{ p: '5px', m: 'auto' }} maxWidth="lg">
            <div className={cx('box-relate')}>
              <div>
                <h3>Bạn cũng có thể tham khảo sim</h3>
              </div>

              <Grid container>
                {arrSim &&
                  arrSim.map((row, i) => (
                    <Grid key={i} item xs={12} md={4} sx={{ display: 'flex' }}>
                      <section className={cx('simtt')} style={{ flex: 1, display: 'flex' }}>
                        <div
                          className={cx('boxSimInfor')}
                          style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                        >
                          <div className={cx('title-sim', 'flex-center-1')}>
                            <div className={cx('flex-center-1', 'h-right')}>
                              <div className={cx('h-mang', `${row?.nhamang}`)}>
                                {row?.nhamang === 'Vietnammobile' ? 'VNMB' : row?.nhamang}
                              </div>
                              <div className={cx('h-sim')}>
                                {row?.sim_show}
                                {row?.price && (
                                  <div className={cx('h-gia')}>
                                    Giá: <strong className={cx('price-last')}>{numberFormat(row?.price)}₫</strong>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={cx('h-left')}>
                              {row?.menh_sim && (
                                <div className={cx('sub-nguhanh', `${row.menh_sim?.split(',')[0] + '-size'}`)}>
                                  <strong className={cx('uppercase')}>
                                    {showMenhSim(row.menh_sim?.split(',')[0])}{' '}
                                  </strong>
                                </div>
                              )}
                              {row?.score && (
                                <div className={cx('h-diem')}>
                                  Điểm<strong className={cx('h-diem-so')}>{row?.score}</strong>
                                </div>
                              )}
                            </div>
                          </div>

                          <p className={cx('text-que-dich')}>Từ trường cuối sim</p>
                          <div className={cx('summary-tags', 'justifyCenter')}>
                            <span className={cx('sim-tag', 'mt-10', `energy-${normalizeClass(row.cap_duoi)}`)}>
                              {row.cap_duoi}
                            </span>
                          </div>
                          <p className={cx('text-y-nghia', 'mt-10')}>{tomtatDuNien[row.cap_duoi]?.yes}</p>

                          <div className={cx('dunien-content')} />

                          <p className={cx('text-que-dich')}>Từ trường trong sim</p>
                          <div className={cx('summary-tags', 'justifyCenter', 'mb-20')}>
                            {row?.dunienin_sim &&
                              row?.dunienin_sim?.split(',').map((t, i) => (
                                <span key={i} className={cx('sim-tag', 'mt-10', `energy-${normalizeClass(t)}`)}>
                                  {t}
                                </span>
                              ))}
                          </div>

                          <div className={cx('g-btn', 'flex-center-1')} style={{ marginTop: 'auto' }}>
                            <a rel="nofollow" className={cx('btn-pt')} href={`/s/${row.sim}`} title={row.sim}>
                              Đặt mua sim
                            </a>
                            <a
                              rel="nofollow"
                              className={cx('btn-pt')}
                              href={`/xem-phong-thuy?so=${row.sim}${cccd ? `&cccd=${cccd}` : ''}${
                                day ? `&ngay=${day}&thang=${month}&nam=${year}&gio=${hour}` : ''
                              }${gender ? `&gioitinh=${gender}` : ''}${isLunar ? `&lich=al` : `&lich=dl`}`}
                              title={`xem boi sim ${row.sim}`}
                            >
                              Luận giải sim
                            </a>
                          </div>
                        </div>
                      </section>
                    </Grid>
                  ))}
              </Grid>
              <Grid container justifyContent={'center'} sx={{ m: 1, pb: 1 }}>
                <Link to={'/so-dep?by=1'}>
                  <div className={cx('summary-actions', 'mt-20')}>
                    <button className={cx('btn-apply', 'flex-center', 'w-full')}>
                      <SearchIcon /> XEM THÊM SIM PHONG THỦY
                    </button>
                  </div>
                </Link>
              </Grid>
            </div>
          </Container>
        </Grid>
      )}
    </Grid>
  );
}
